import Swiper from 'swiper';
import $ from 'jquery';

const plg = require('./autoload/functions-comunes');

export default {
	init() {
		// Inicializa comportamientos globales de la tienda
		this.initBestSellersSwiper();
		this.bindAddToCart();
		this.bindTiendaControls();
		this.bindToggleMenu();
        this.initProductSwiper();
		this.initQuantity();
		this.initCartSidebar();
        console.log('store-common.js initialized');
	},

	initQuantity() {

		document.addEventListener('DOMContentLoaded', function () {
			document.querySelectorAll('.quantity').forEach(function (wrapper) {


						console.log("hay");

				const input = wrapper.querySelector('input.qty');
				if (!input || wrapper.querySelector('.quantity-button')) return;

				const minus = document.createElement('button');
				minus.type = 'button';
				minus.className = 'quantity-button';
				minus.textContent = '−';

				const plus = document.createElement('button');
				plus.type = 'button';
				plus.className = 'quantity-button';
				plus.textContent = '+';

				minus.addEventListener('click', () => {
					const val = parseInt(input.value) || 1;
					const min = parseInt(input.min) || 1;
					if (val > min) input.value = val - 1;
					input.dispatchEvent(new Event('change'));
				});

				plus.addEventListener('click', () => {
					const val = parseInt(input.value) || 1;
					const max = parseInt(input.max) || Infinity;
					if (val < max) input.value = val + 1;
					input.dispatchEvent(new Event('change'));
				});

				wrapper.insertBefore(minus, input);
				wrapper.appendChild(plus);
			});
		});

	},

	bindToggleMenu() {
		// Compatibilidad con toggles del tema: priorizar el navbar de tienda (`#shopNavbar`) en header
		// $(document).ready(function(){
		// 	var $sub = $('.mod-sidebar .submenu');
		// 	var $shop = $('#shopNavbar');
		// 	var $toggler = $('.navbar-toggler[data-bs-target="#shopNavbar"], .navbar-toggler[data-target="#shopNavbar"]');
		// 	// Ocultar por defecto en móvil los contenedores que puedan estar expandidos
		// 	if ($sub.length && ($('.js-togglemenu').is(':visible') || $(window).width() <= 767)) {
		// 		$sub.hide();
		// 	}
		// 	if ($shop.length && $toggler.length && $(window).width() <= 767) {
		// 		$shop.hide();
		// 		$toggler.attr('aria-expanded', 'false');
		// 	}
		// });

		// Compatibilidad con toggles del tema: priorizar el navbar de tienda (`#shopNavbar`) en header
		$(document).ready(function(){
			var $shop = $('#shopNavbar');
			var $toggler = $('.navbar-toggler[data-bs-target="#shopNavbar"], .navbar-toggler[data-target="#shopNavbar"]');
			if ($shop.length && $(window).width() <= 767) {
				$shop.hide();
				$toggler.attr('aria-expanded', 'false');
			}
		});		
	

		// Si existe un toggler para #shopNavbar, usarlo para alternar el navbar en móvil
		$(document).on('click', '.navbar-toggler[data-bs-target="#shopNavbar"], .navbar-toggler[data-target="#shopNavbar"]', function(e){
			e.preventDefault();
			var $shop = $('#shopNavbar');
			var $btn = $(this);
			if ($shop.length) {
				$shop.slideToggle();
				var expanded = $btn.attr('aria-expanded') === 'true';
				$btn.attr('aria-expanded', expanded ? 'false' : 'true');
			}
		});

		// // Fallback: si se hace click en `.js-togglemenu` controlar sidebar existente
		// $(document).on('click', '.js-togglemenu', function(e){
		// 	e.preventDefault();
		// 	var $sub = $('.mod-sidebar .submenu');
		// 	if ($sub.length) {
		// 		$sub.slideToggle();
		// 	}
		// });

		// Al clicar una ancla del menú, cerrar el navbar responsive si está abierto
		$(document).on('click', '#shopNavbar a', function(e){
			var $shop = $('#shopNavbar');
			var $toggler = $('.navbar-toggler[data-bs-target="#shopNavbar"], .navbar-toggler[data-target="#shopNavbar"]');
			if ($shop.length && $shop.is(':visible') && $toggler.is(':visible')){
				$shop.slideUp();
				$toggler.attr('aria-expanded','false');
			}
		});
	},


	initBestSellersSwiper() {
		if (typeof Swiper === 'undefined') return;
		const container = document.querySelector('.best-sellers-swiper');
		if (!container) return;
		if (container.__rpd_swiper) return;
		container.__rpd_swiper = new Swiper('.best-sellers-swiper', {
			slidesPerView: 3,
			spaceBetween: 16,
			navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
			pagination: { el: '.swiper-pagination', clickable: true },
			loop: false,
			watchOverflow: true
		});
	},

	initProductSwiper() {
		if (typeof Swiper === 'undefined') return;
		const container = document.querySelector('.product-swiper');
		if (!container) return;
		if (container.__rpd_swiper) return;
		container.__rpd_swiper = new Swiper('.product-swiper', {
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: { nextEl: '.product-swiper .swiper-button-next', prevEl: '.product-swiper .swiper-button-prev' },
			loop: false,
			watchOverflow: true
		});
	},

	bindAddToCart() {
		// Delegated click: interceptar TODOS los botones de añadir al carrito
		$(document.body).on('click', '.add_to_cart_button, .single_add_to_cart_button, .ajax_add_to_cart', function(e){
			e.preventDefault();
			var $btn = $(this);
			var $form = $btn.closest('form.cart');
			var dataObj = {};

			// Serializar formulario si existe, sino usar data attributes del botón
			if ($form.length) {
				$form.serializeArray().forEach(function(item){
					dataObj[item.name] = item.value;
				});
			} else {
				$.each($btn.data(), function(k, v){ dataObj[k] = v; });
			}

			// Garantizar que exista product_id (varios themes usan 'product_id' o 'add-to-cart')
			if (!dataObj.product_id) {
				var pid = null;
				if ($form.length) {
					pid = $form.find('input[name="product_id"]').val() || $form.find('input[name="add-to-cart"]').val();
				}
				if (!pid) {
					pid = $btn.data('product_id') || $btn.attr('data-product_id') || $btn.attr('data-product-id') || $btn.attr('value');
				}
				if (pid) dataObj.product_id = pid;
			}

			// Intentar añadir product_sku si existe
			if (!dataObj.product_sku) {
				var sku = null;
				if ($form.length) sku = $form.find('input[name="product_sku"]').val();
				if (!sku) sku = $btn.data('product_sku') || $btn.attr('data-product_sku') || $btn.attr('data-product-sku');
				if (sku) dataObj.product_sku = sku;
			}

			// Asegurar quantity
			if (!dataObj.quantity) dataObj.quantity = $btn.data('quantity') || 1;

			// Determinar URL AJAX de WooCommerce
			var ajaxUrl = '/?wc-ajax=add_to_cart';
			if (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.wc_ajax_url) {
				ajaxUrl = wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart');
			}

			// Estado de loading
			$btn.prop('disabled', true).addClass('is-loading');
			console.log('Enviando AJAX add_to_cart con datos:', dataObj, 'URL:', ajaxUrl);

			$.post(ajaxUrl, dataObj, function(response){
				$btn.prop('disabled', false).removeClass('is-loading');
				console.log('Respuesta AJAX add_to_cart:', response);

				var fragmentsUpdated = false;
				if (response && response.fragments) {
					// Actualizar todos los fragmentos devueltos por WooCommerce
					$.each(response.fragments, function(key, val){
						try { 
							$(key).replaceWith(val);
							console.log('Fragment actualizado:', key);
							fragmentsUpdated = true;
						} catch (e) { 
							console.warn('No se pudo actualizar fragment:', key, e);
						}
					});
					if (response.cart_hash) {
						$(document.body).data('wc_cart_hash', response.cart_hash);
					}
					
					// Si se actualizaron fragmentos, disparar eventos
					if (fragmentsUpdated) {
						$(document.body).trigger('wc_fragments_refreshed', [response.fragments, response.cart_hash]);
						$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $btn]);
					}
				}

				// Si no hay fragmentos o faltó actualizar el carrito, hacer AJAX para recargar
				if (!fragmentsUpdated) {
					console.log('Recargando fragmentos vía AJAX adicional');
					var refreshUrl = typeof wc_cart_fragments_params !== 'undefined' ? 
						'/wp-admin/admin-ajax.php' : '/wp-admin/admin-ajax.php';
					
					$.post(
						refreshUrl,
						{ 
							action: 'woocommerce_get_refreshed_fragments', 
							nonce: (typeof wc_cart_fragments_params !== 'undefined' && wc_cart_fragments_params.nonce) ? wc_cart_fragments_params.nonce : '' 
						},
						function(refreshed) {
							if (refreshed && refreshed.fragments) {
								$.each(refreshed.fragments, function(key, val){
									try { 
										$(key).replaceWith(val); 
										console.log('Fragment recargado:', key);
										fragmentsUpdated = true;
									} catch (e) { 
										console.warn('No se pudo recargar fragment:', key, e);
									}
								});
								if (refreshed.cart_hash) {
									$(document.body).data('wc_cart_hash', refreshed.cart_hash);
								}
								$(document.body).trigger('wc_fragments_refreshed', [refreshed.fragments, refreshed.cart_hash]);
								$(document.body).trigger('added_to_cart', [refreshed.fragments, refreshed.cart_hash, $btn]);
							}
						},
						'json'
					);
				}

				// Mostrar error si existe
				if (response && response.error) {
					var msg = response.error;
					if ($form && $form.length) {
						var $notice = $form.find('.woocommerce-error, .woocommerce-message').first();
						if ($notice.length) {
							$notice.text(msg).show();
						} else {
							$form.prepend('<div class="woocommerce-error">' + msg + '</div>');
						}
					} else {
						alert(msg);
					}
				} else if (!fragmentsUpdated && !response) {
					// Si no hay respuesta ni fragmentos, mostrar error
					var msg = 'No se pudo añadir al carrito.';
					if ($form && $form.length) {
						var $notice = $form.find('.woocommerce-error, .woocommerce-message').first();
						if ($notice.length) {
							$notice.text(msg).show();
						} else {
							$form.prepend('<div class="woocommerce-error">' + msg + '</div>');
						}
					}
				}
			}).fail(function(jqXHR, textStatus, errorThrown){
				$btn.prop('disabled', false).removeClass('is-loading');
				console.error('Error en AJAX add_to_cart:', textStatus, errorThrown);
				
				if ($form && $form.length) {
					$form.prepend('<div class="woocommerce-error">Error de conexión. Intenta de nuevo.</div>');
				} else {
					alert('Error de conexión. Intenta de nuevo.');
				}
			});
		});
	}
	,

	// AJAX: carga productos filtrados y paginación (migrado desde archive-product.php)
	tiendaFetch(params, pushState) {
		var ajaxUrl = (window.global && window.global.ajax_url) ? window.global.ajax_url : '/wp-admin/admin-ajax.php';
		var data = new URLSearchParams();
		data.append('action','tienda_load');
		if (params.product_cat) data.append('product_cat', params.product_cat);
		if (params.orderby) data.append('orderby', params.orderby);
		if (params.paged) data.append('paged', params.paged);
		if (params.posts_per_page) data.append('posts_per_page', params.posts_per_page);

		var self = this;
		fetch(ajaxUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }, body: data.toString() })
			.then(function(r){ return r.json(); })
			.then(function(json){
				if (json.success) {
					var container = document.getElementById('tienda-products');
					if (container) {
						container.innerHTML = json.data.html;
						// IMPORTANTE: trigger custom event para reinicializar delegación de eventos en nuevos botones
						$(document.body).trigger('tienda_products_updated');
					}
					// rebind pagination links if needed (delegation used elsewhere)
					if (pushState) {
						var url = new URL(window.location.href);
						if (params.product_cat) url.searchParams.set('product_cat', params.product_cat); else url.searchParams.delete('product_cat');
						if (params.orderby) url.searchParams.set('orderby', params.orderby); else url.searchParams.delete('orderby');
						if (params.paged) url.searchParams.set('paged', params.paged); else url.searchParams.delete('paged');
						history.pushState({}, '', url.toString());
					}
				}
			});
	},

	initCartSidebar() {

		console.log("initCartSidebar called");

		var setupCart = function () {

			console.log("setupCart called");

			var sidebar = document.getElementById('cart-sidebar');
			var overlay = document.getElementById('cart-sidebar-overlay');
			if (!sidebar || !overlay) return;

			// Insertar botón cerrar dentro del widgettitle si no existe
			var title = sidebar.querySelector('.widgettitle');
			if (title && !title.querySelector('.cart-sidebar__close')) {
				var closeBtn = document.createElement('button');
				closeBtn.className = 'cart-sidebar__close';
				closeBtn.setAttribute('aria-label', 'Cerrar carrito');
				title.appendChild(closeBtn);
			}

			var openCart = function () {
				sidebar.classList.add('is-open');
				overlay.classList.add('is-open');
				document.body.style.overflow = 'hidden';
				console.log('Carrito abierto');
			};

			var closeCart = function () {
				sidebar.classList.remove('is-open');
				overlay.classList.remove('is-open');
				document.body.style.overflow = '';
				console.log('Carrito cerrado');
			};

			// Abrir al añadir producto — AJAX (evento WooCommerce) con namespace
			$(document.body).off('added_to_cart.cart-sidebar').on('added_to_cart.cart-sidebar', function (e, fragments, cart_hash, btn) {
				console.log('added_to_cart.cart-sidebar event fired', {fragments, cart_hash});
				openCart();
			});
			
			// Abrir al añadir producto — fallback (delegación para botones dinámicos)
			$(document).off('click.cart-sidebar-btn', '.add_to_cart_button').on('click.cart-sidebar-btn', '.add_to_cart_button', function () {
				console.log('add_to_cart_button clicked (fallback)');
				setTimeout(function () {
					if ($(document.body).data('wc_cart_hash')) {
						openCart();
					}
				}, 800);
			});

			// Cerrar con botón X
			var closeBtn2 = sidebar.querySelector('.cart-sidebar__close');
			if (closeBtn2) {
				closeBtn2.removeEventListener('click', closeCart);
				closeBtn2.addEventListener('click', closeCart);
			}
			
			// Cerrar al clickear el overlay
			overlay.removeEventListener('click', closeCart);
			overlay.addEventListener('click', closeCart);
			
			// Cerrar con tecla Escape
			document.removeEventListener('keydown', closeCart);
			document.addEventListener('keydown', function (e) {
				if (e.key === 'Escape') closeCart();
			});
		};

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', setupCart);
		} else {
			setupCart();
		}

		// Re-inicializar setupCart cuando se recargan productos vía AJAX (listados)
		$(document.body).on('tienda_products_updated', function() {
			console.log('tienda_products_updated event received, reinitializing cart sidebar handlers');
			setupCart();
		});
		
		// También re-inicializar cuando se actualizan fragmentos del carrito
		$(document.body).on('wc_fragments_refreshed', function() {
			console.log('wc_fragments_refreshed event received, reinitializing cart sidebar handlers');
			setupCart();
		});
	},

	bindTiendaControls() {
        console.log("bindTiendaControls called");
		// Category link clicks
		$(document).on('click', '.product-categories a', function(e){
			e.preventDefault();
			var el = e.currentTarget;
			var cat = (el.dataset && el.dataset.cat) ? el.dataset.cat : $(el).data('cat') || '';
			if (!cat) {
				try {
					var href = el.getAttribute('href');
					var url = new URL(href, window.location.origin);
					cat = url.searchParams.get('product_cat') || '';
				} catch (err) { cat = ''; }
			}
			var orderby = ($('#orderby').length) ? $('#orderby').val() : '';
			var self = this;
			self.tiendaFetch({ product_cat: cat, orderby: orderby, paged: 1 }, true);
		}.bind(this));

		// Order select change
		$(document).on('change', '#orderby', function(e){
			var cat = new URL(window.location.href).searchParams.get('product_cat') || '';
			var orderby = $(e.currentTarget).val();
			var self = this;
			self.tiendaFetch({ product_cat: cat, orderby: orderby, paged: 1 }, true);
		}.bind(this));

		// Delegated pagination clicks
		$(document).on('click', '.tienda-pagination a', function(e){
			e.preventDefault();
			var href = $(e.currentTarget).attr('href');
			var url = new URL(href, window.location.origin);
			var paged = url.searchParams.get('paged') || 1;
			var cat = new URL(window.location.href).searchParams.get('product_cat') || '';
			var orderby = ($('#orderby').length) ? $('#orderby').val() : '';
			var self = this;
			self.tiendaFetch({ product_cat: cat, orderby: orderby, paged: paged }, true);
		}.bind(this));
	}
};


// WEBPACK FOOTER //
// ./scripts/store-common.js